import { useMemo } from 'react'
import { useRecoilState } from 'recoil'

import { useIDTagging } from '../id-tagging'
import { $translationCtx, Translation } from './atom'

const SYSTEM_TAG = 'system'

const getIDTaggingFromIDML = (idml: string, ctx: Translation) => {
  if (!idml) {
    return ''
  }
  if (ctx.data?.[idml]?.isSystem) {
    const msName = SYSTEM_TAG
    let sectionName = SYSTEM_TAG
    if (ctx.data?.[idml]?.sectionName && ctx.data?.[idml]?.sectionName !== ctx.data?.[idml]?.msName) {
      sectionName = ctx.data?.[idml]?.sectionName
    }
    return `{${msName}-${sectionName}-${idml}}`
  }
  const msName = ctx.data?.[idml]?.msName
  const sectionName = ctx.data?.[idml]?.sectionName
  return `{${msName}-${sectionName}-${idml}}`
}

/**
 * The `useTranslation` function returns a translation for a given IDML key, or a default description
 * if the translation is not available.
 * @returns The `useTranslation` function returns a memoized function that takes in two parameters:
 * `idml` (a string) and `description` (a string). Inside the memoized function, it checks if
 * `ctx.data[idml]` exists and is not an empty string. If it does, it returns `ctx.data[idml]`,
 * otherwise it returns `description`.
 */
export function useTranslation() {
  const [ctx] = useRecoilState($translationCtx)
  const idTaggingEnabled = useIDTagging()

  return useMemo(() => {
    return (idml: string, description: string) => {
      return idTaggingEnabled
        ? getIDTaggingFromIDML(idml, ctx)
        : ctx.data?.[idml]?.tDescription
        ? ctx.data[idml].tDescription
        : description
    }
  }, [ctx, idTaggingEnabled])
}
